// -----------------------------------------------------------------------------
// Slider on the the page cooperation
// -----------------------------------------------------------------------------

// Slider
function accSlider() {
  var numSlick = 0;
  $('.apartment-full').each(function () {
    numSlick++;
    $(this).addClass('apartment-full-' + numSlick).slick({
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrow: false,
      asNavFor: '.apartment-thumbs-' + numSlick,
      focusOnSelect: true
    });
  });

  numSlick = 0;
  $('.apartment-thumbs').each(function () {
    numSlick++;
    $(this).addClass('apartment-thumbs-' + numSlick).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrow: false,
      asNavFor: '.apartment-full-' + numSlick,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 2,
          }
        }
      ]
    });
  });
};